import { Component } from '@verndale/core';
import orderBy from 'lodash/orderBy';
import isEmail from 'validator/lib/isEmail';
import { getNames } from 'country-list';
import Choices from 'choices.js';
import tingle from 'tingle.js';

class NewsSubscribe extends Component {
  setupDefaults() {
    this.dom = {
      $subscribeModalTrigger: this.$el.find(
        '.news-subscribe__banner__content-btn'
      ),
      $modal: this.$el.find('.news-subscribe__modal'),
      $modalCloseButton: this.$el.find('.news-subscribe__modal__close'),
      $modalTitle: this.$el.find('.news-subscribe__modal__title'),
      $modalForm: this.$el.find('.news-subscribe__modal__form'),
      $modalIcon: this.$el.find('.news-subscribe__modal__icon-container'),
      $modalFormButton: this.$el.find('.news-subscribe__modal__form > button'),
      $countrySelect: this.$el.find('.js-country-selector'),
      $typeSelect: this.$el.find('.js-type-selector')
    };
    this.initSelect();
  }

  addListeners() {
    this.dom.$subscribeModalTrigger.on('click', ::this.createModal);
    this.dom.$modalCloseButton.on('click', ::this.closeModal);
    this.dom.$modalForm.on('submit', ::this.onFormSubmit);
  }

  initSelect() {
    const countriesNames = orderBy(getNames());
    const countries = countriesNames
      .map(country => `<option value="${country}">${country}</option>`)
      .join('');
    this.dom.$countrySelect.append(countries);
    const config = {
      searchEnabled: false,
      searchChoices: false,
      itemSelectText: '',
      shouldSort: false
    };
    this.countryChoices = new Choices(this.dom.$countrySelect[0], config);
    this.typeChoices = new Choices(this.dom.$typeSelect[0], config);
  }

  createModal() {
    this.dom.$modal.removeAttr('hidden');

    this.modal = new tingle.modal({
      closeMethods: ['overlay', 'escape'],
      cssClass: ['tingle-news-subscribe-modal'],
      onClose: () => this.onModalClose()
    });

    this.modal.setContent(this.dom.$modal[0]);
    this.modal.open();
  }

  onModalClose() {
    this.dom.$modalForm.show().trigger('reset');
    this.countryChoices.setChoiceByValue('');
    this.typeChoices.setChoiceByValue('');
    $(this.dom.$modalTitle[0]).show();
    $(this.dom.$modalTitle[1]).hide();
    this.dom.$modalIcon.removeClass('active');
    this.dom.$modalFormButton.prop('disabled', false);
  }

  closeModal() {
    if (this.modal) {
      this.modal.close();
      this.modal = null;
    }
  }

  async onFormSubmit(e) {
    e.preventDefault();
    const redirectUrl = this.dom.$modalForm.attr('action');
    const endpoint = $(e.target).data('url');
    const serializedData = $(e.target).serializeArray();
    const email = serializedData.find(({ name }) => name === 'EMAIL').value;
    if (isEmail(email)) {
      this.dom.$modalFormButton.prop('disabled', true);
      let data = {};
      serializedData.map(
        ({ name, value }) => (data = { ...data, [name]: value })
      );
      $.ajax({
        url: endpoint,
        type: 'POST',
        data,
        dataType: 'jsonp',
        contentType: 'application/json; charset=utf-8'
      });
      this.dom.$modalForm.hide();
      $(this.dom.$modalTitle[0]).hide();
      $(this.dom.$modalTitle[1]).show();
      this.dom.$modalIcon.addClass('active');
      window.location.href = redirectUrl;
    }
  }
}

export default NewsSubscribe;
